import { render, staticRenderFns } from "./setpwd.vue?vue&type=template&id=7a4a0cd4&scoped=true&"
import script from "./setpwd.vue?vue&type=script&lang=js&"
export * from "./setpwd.vue?vue&type=script&lang=js&"
import style0 from "./setpwd.vue?vue&type=style&index=0&id=7a4a0cd4&lang=less&scoped=true&"
import style1 from "./setpwd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a0cd4",
  null
  
)

export default component.exports